import React, { useCallback } from 'react';
import queryString from 'query-string';
import { useActionDispatchOnMount } from 'core/store/store';
import { makeAppInitSellingAction } from 'state/app/actions';
import { FullScreenLoader } from 'components/Loader/Loader';
import { useSelector } from 'react-redux';
import { appInitSellingFailureSelector } from 'state/app/selectors';
import { Text, TextTypography } from 'components/Text/Text';
import { RoutePath } from 'RoutePath';
import { LargeButton } from 'components/LargeButton/LargeButton';
import i18n from '../../../i18n';

export const Selling = () => {
    const search = queryString.parse(window.location.search);
    const errorSelling = useSelector(appInitSellingFailureSelector);
    const { t } = i18n.useTranslation();

    const onFeedClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    useActionDispatchOnMount(true, makeAppInitSellingAction, search?.storeId, search?.code);
    return errorSelling ? (
        <div
            style={{
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
        >
            <Text typography={TextTypography.BODY_ACCENT}>{errorSelling}</Text>
            <Text typography={TextTypography.BODY}>{t('common:errors.contactTechSupport')}</Text>
            <div style={{ marginTop: 16, width: 300 }}>
                <LargeButton onClick={onFeedClick}>{t('common:navigateToMain')}</LargeButton>
            </div>
        </div>
    ) : (
        <FullScreenLoader />
    );
};
